import { data } from '../../svg/SDK/data';
import { makeIcon } from '../makeIcon';

export const SDK = makeIcon(data, 'sdk', 'SDK');

export default SDK;
